<template lang="html">
    <div class="cell-container">
        <button class="cell-action" @click="btnClickedHandler()" :disabled="matched" :class="{ 'green-cell': matched }">{{ value }}</button>
    </div>
</template>
<script>
export default {
    name: 'MatchCellRenderer',
    data() {
        return {

        }
    },
    methods: {
        btnClickedHandler() {
            this.params.clicked(this.params.data);
        }
    },
    computed: {
        matched: {
            get() {
                // return this.params.data.lnoCode % 2 != 0;
                return this.params.data.point;
            }
        },
        value() {
            return this.matched ? 'Matched' : 'Select';
        }
    }
}
</script>
<style lang="css">
.cell-container {
    display: flex;
    justify-content: start;
    align-items: center;
    height: 100%;
    width: 100%;
}

.cell-action:disabled {
    cursor: default;
}

.cell-action.green-cell {
    background-color: rgb(96 183 58);
}

.cell-action {
    cursor: pointer;
    background-color: rgb(234 142 142);
    color: white;
    border: none;
    height: 30px;
    border-radius: 5px;
    width: -webkit-fill-available;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding: 0px 10px;
}
</style>